import GrafHistoricosInv from './GrafHistoricosInv';
import GrafHistoricosPot from './GrafHistoricosPot';
import { Tab, Tabs } from 'react-bootstrap';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

function VerHistoricos() {
    const { t } = useTranslation();
    var [code, setCode] = useState(null);
    if (code == null) {
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }

    window.addEventListener("orientationchange", function () {
        window.location.reload();
    });

    return (
        <div className='div-tabs-meteo'>
            <Tabs defaultActiveKey="Inversor">
                <Tab eventKey="Inversor" title={t('scada.solarFarm.historical.inverter')}>
                    <GrafHistoricosInv />
                </Tab>
                <Tab eventKey="Potencia" title={t('scada.solarFarm.historical.power')}>
                    <GrafHistoricosPot />
                </Tab>
            </Tabs>
        </div>
    );
};

export default VerHistoricos;